import { useCustomScrollToTop } from './useCustomScrollToTop';
import { pageHasStickyHeader } from './pageHasStickyHeader';
import { useMedia } from 'react-use';
import { useLayoutContext } from '../provider/layout/LayoutContext';

export const useOpenSignForm = () => {
  const { setShowFormByName } = useLayoutContext();
  const isMobile = useMedia('(max-width: 1025px)', false);
  const { goToTop } = useCustomScrollToTop();
  const { hasSticky } = pageHasStickyHeader();

  const signFormOpen = (formType) => {
    setShowFormByName(formType);
    if (!isMobile && !hasSticky) {
      goToTop();
    }
  };

  return { signFormOpen };
};
